import { inject } from '@angular/core';
import { map } from 'rxjs';
import { AuthService } from './auth.service';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

export const AuthGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  return auth.currentUser$.pipe(
    map((user) => {
      if (user) {
        return true;
      }

      router.navigate(['login'], {
        queryParams: { returnUrl: state.url },
      });
      return false;
    })
  );
};
